export const maskedPhone = (phone: string) => {
  const mask = new RegExp(`(^\\d{${(phone.length || 0) % 10}})(\\d{3})(\\d{3})(\\d{2})(\\d{2}$)`);

  return phone?.replace(mask, '+7 ($2) $3-$4-$5');
};
